<template>
	<div class="following-container">
		<div class="title">
			关注列表
		</div>
		<div class="followList" v-if="followData.length">
			<div class="followItem" v-for="(item,index) in followData" :key="index">
				<div class="followInfo" @click="naviToPainter(item)">
					<img class="avatar" :src="item.user.avatar" v-if="item.user.avatar" />
					<img class="avatar" src="../assets/Personal/iconF.png" v-else />
					<div class="nameWorkFuns">
						<div class="name">
							{{item.user.user_nickname ? item.user.user_nickname : ''}}
						</div>
						<div class="workFuns">
							<span>作品：{{item.zuopin}}</span>
							<div class="line"></div>
							<span>粉丝：{{item.fensi}}</span>
						</div>
					</div>
				</div>
				<!-- <div class="follow">
					关注
				</div> -->
				<div class="unFollow" @click.stop="huaGuanZhu(item)">
					取消关注
				</div>
			</div>
		</div>
		<el-empty description="暂无数据" v-else></el-empty>
		<PagePagination v-if="total > 0" style="padding: .32rem 0 .4rem;" :currentPage="currentPage" :total="total"
			@current-change="onPageChange" />
		<!-- <div class="title">
			最新作品
		</div>
		<div class="offical-recommendation-container">
			<div class="swiper-container-official">
				<div class="swiper-wrapper">
					<div class="swiper-slide">
						<img src="https://picsum.photos/id/1/600/400" alt="山水画" class="official-image">
					</div>
					<div class="swiper-slide">
						<img src="https://picsum.photos/id/137/600/400" alt="海洋生物" class="official-image">
					</div>
					<div class="swiper-slide">
						<img src="https://picsum.photos/id/1015/600/400" alt="人物" class="official-image">
					</div>
					<div class="swiper-slide">
						<img src="https://picsum.photos/id/1024/600/400" alt="自然风景" class="official-image">
					</div>
					<div class="swiper-slide">
						<img src="https://picsum.photos/id/1043/600/400" alt="建筑风景" class="official-image">
					</div>
					<div class="swiper-slide">
						<img src="https://picsum.photos/id/1043/600/400" alt="建筑风景" class="official-image">
					</div>
					<div class="swiper-slide">
						<img src="https://picsum.photos/id/1043/600/400" alt="建筑风景" class="official-image">
					</div>
				</div>
				<div class="swiper-button-prev-official">
					<img class="arrowIcon" src="../assets/Home/leftArrow.png" />
				</div>
				<div class="swiper-button-next-official">
					<img class="arrowIcon" src="../assets/Home/rightArrow.png" />
				</div>
			</div>
		</div> -->
	</div>
</template>

<script>
	import PagePagination from '../components/PagePagination.vue'
	import Swiper from 'swiper'
	import 'swiper/css/swiper.css'

	export default {
		name: 'FollowingList',
		components: {
			PagePagination,
		},
		data() {
			return {
				officialSwiper: null,
				followData: [],
				currentPage: 1, // 当前页码
				total: 1, // 总条数
			}
		},
		mounted() {
			this.followList()
			// this.initOfficialSwiper()
		},
		beforeUnmount() {
			if (this.officialSwiper) {
				this.officialSwiper.destroy(true, true)
			}
		},
		methods: {
			naviToPainter(item) {
				this.$router.push({
					path: '/painter-homepage',
					query: {
						id: item.mb_id
					}
				})
			},
			followList() {
				this.$api.post('Hua/guanzhu_list', {
					p: this.currentPage
				}).then(res => {
					if (res.code == 1) {
						this.followData = res.data.list
						this.total = res.data.count
					}
				}).catch(err => {
					console.log(err);
				})
			},
			//取消关注画师
			huaGuanZhu(item) {
				this.$api.post('/Hua/guanzhu', {
					mb_id: item.mb_id
				}).then(res => {
					if (res.code == 1) {
						this.$message.success(res.msg)
						this.followList()
					}
				}).catch(err => {
					console.log(err);
				})
			},
			onPageChange(newPage) {
				this.currentPage = newPage
				this.followList()
			},
			initOfficialSwiper() {
				// 创建官方推荐Swiper实例
				this.officialSwiper = new Swiper('.swiper-container-official', {
					slidesPerView: 'auto',
					centeredSlides: true,
					spaceBetween: 20,
					loop: true,
					autoplay: {
						delay: 50000,
						disableOnInteraction: false
					},
					navigation: {
						nextEl: '.swiper-button-next-official',
						prevEl: '.swiper-button-prev-official',
					},
					effect: 'coverflow',
					coverflowEffect: {
						rotate: 0,
						stretch: 0,
						depth: 100,
						modifier: 3,
						slideShadows: false
					}
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	.following-container {
		width: 100%;
		padding: .32rem .4rem;
		border-radius: .08rem;
		background: #FFFFFF;
	}

	.title {
		font-weight: 600;
		font-size: .16rem;
		color: #333333;
	}

	.followList {
		display: flex;
		flex-wrap: wrap;

		.followItem:nth-child(2n) {
			margin-right: 0;
		}

		.followItem {
			margin-top: .24rem;
			margin-right: .23rem;
			width: 4.26rem;
			height: .92rem;
			border-radius: .08rem;
			border: .01rem solid #CCCCCC;
			display: flex;
			align-items: center;
			justify-content: space-between;
			padding: 0 .24rem;

			.followInfo {
				display: flex;
				align-items: center;
				cursor: pointer;

				.avatar {
					width: .6rem;
					height: .6rem;
					overflow: hidden;
					border-radius: 50%;
					object-fit: cover;
				}

				.nameWorkFuns {
					display: flex;
					flex-direction: column;
					margin-left: .12rem;

					.name {
						font-weight: 500;
						font-size: .16rem;
						color: #252525;
					}

					.workFuns {
						display: flex;
						align-items: center;
						font-weight: 400;
						font-size: .12rem;
						color: #252525;

						.line {
							width: .01rem;
							height: .1rem;
							margin: 0 .12rem;
						}
					}
				}
			}

			.follow {
				width: .88rem;
				height: .36rem;
				background: #E29358;
				border-radius: .04rem;
				font-weight: 400;
				font-size: .14rem;
				color: #FFFFFF;
				line-height: .36rem;
				text-align: center;
			}

			.unFollow {
				width: .88rem;
				height: .36rem;
				background: rgba(226, 147, 88, .2);
				border-radius: .04rem;
				font-weight: 400;
				font-size: .14rem;
				color: #E29358;
				line-height: .36rem;
				text-align: center;
				cursor: pointer;
			}
		}
	}

	.offical-recommendation-container {
		width: 100%;
		display: flex;
		flex-direction: column;
	}

	.swiper-container-official {
		margin: .6rem auto 0;
		width: 8.75rem;
		position: relative;
		overflow: hidden;
	}

	.swiper-wrapper {
		height: 100%;
		width: 7.15rem;
	}

	.swiper-slide {
		width: 2.16rem;
		height: 3.48rem;
		transform: scale(0.8);
		transition: all 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94);
		z-index: 1;
	}

	.swiper-slide-active {
		transform: scale(1);
		z-index: 3;
	}

	.swiper-slide-prev,
	.swiper-slide-next {
		transform: scale(0.8);
		z-index: 2;
	}

	.swiper-slide-duplicate-active {
		transform: scale(1);
		z-index: 3;
	}

	.official-image {
		width: 100%;
		height: 100%;
		object-fit: cover;
		transition: transform 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94);
	}

	/* 导航箭头样式 */
	.swiper-button-prev-official,
	.swiper-button-next-official {
		position: absolute;
		top: 0%;
		width: .9rem;
		height: 100%;
		display: flex;
		align-items: center;
		background: #FDFDF4;
		z-index: 5;

		.arrowIcon {
			width: .36rem;
			height: .36rem;
			cursor: pointer;
		}
	}

	.swiper-button-prev-official {
		left: 0%;
		justify-content: flex-start;
	}

	.swiper-button-next-official {
		right: 0%;
		justify-content: flex-end;
	}
</style>